import {
  CardStatusEnum,
  CardTypeEnum,
  FullName,
  ICard,
  Query,
} from '@varo/graphql-schema-types';
import { useEffect } from 'react';
import FetchAccountIDCards from 'services/graphql/queries/FetchAccountIDCards';
import FetchCardUser from 'services/graphql/queries/FetchCardUser';
import { AnyVariables, useQuery } from 'urql';

export type CardUserType = {
  card: ICard;
  user: { customerInfo: { name: FullName } };
};

export const useFetchCardUserData = () => {
  const [{ data: cardsData, error, fetching }] = useQuery<Query, AnyVariables>({
    query: FetchAccountIDCards,
    requestPolicy: 'network-only',
  });

  const cards = cardsData?.cards;
  const cardId = cards?.find(
    (card) =>
      card.status !== CardStatusEnum.LostStolenBroken &&
      card.status !== CardStatusEnum.New &&
      card.type === CardTypeEnum.DebitCard &&
      card.isLocked === false,
  )?.id;

  const [{ data: cardUserData }, refetchCardUserDetails] =
    useQuery<CardUserType>({
      query: FetchCardUser,
      variables: { cardId: cardId },
      requestPolicy: 'cache-and-network',
      pause: true,
    });

  useEffect(() => {
    if (cardId) {
      refetchCardUserDetails();
    }
  }, [cardId, refetchCardUserDetails]);

  return {
    sourceData: cardUserData,
    error,
    fetching,
    cardId,
  };
};
